// extracted by mini-css-extract-plugin
module.exports = {"tag-wrapper":"story-tags-m__tag-wrapper__3d5Ur","tag-element":"story-tags-m__tag-element__1PpQf"};